var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discount",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7283",
    "data-name": "Rectangle 7283",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M2,15.429,13.429,4h7.143v7.143L9.143,22.571Z",
    transform: "translate(-2 -2.571)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 1.429,
    cy: 1.429,
    r: 1.429,
    transform: "translate(13.571 3.571)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y1: 4.286,
    x2: 4.286,
    transform: "translate(15.714 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 5.714,
    y2: 5.714,
    transform: "translate(5 6.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 2.857,
    y2: 2.857,
    transform: "translate(10.714 9.286)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.cc50988908e8704ce094818027255a2a.svg";
export { ForwardRef as ReactComponent };